<div class="settings-card">
    <div class="settings-card__header">
        <img src="/assets/images/calendar-programari.svg" alt="" />
        <div class="settings-card__header-headline d-flex justify-content-between flex-column gap-4">
            <h2 class="m-0">Înregistrare programare</h2>
            <h4 class="m-0">În cadrul acestui portal puteți să vă gestionați programările ședințelor speciale din cadrul
                locațiilor Direcției Generale de Asistență Socială și Protecția Copilului Sector 4</h4>
        </div>
    </div>
</div>

<div class="inregistrare-container">
    <div class="inregistrare-content">

        <!-- TOGGLE -->
        <div class="mode-toggle">
            <button class="mode-btn" [class.mode-btn--active]="mode === 'initializare'"
                (click)="setMode('initializare')">
                Înregistrare nouă
            </button>
            <button class="mode-btn" [class.mode-btn--active]="mode === 'drafturi'" (click)="setMode('drafturi')">
                Drafturi
            </button>
        </div>

        <!-- ═══════════════ INITIALIZARE ═══════════════ -->
        <ng-container *ngIf="mode === 'initializare'">
            <span class="inregistrare-content-title">Identificare copil</span>

            <div class="inregistrare-content-form d-flex gap-3">
                <div class="inregistrare-content-form-left">
                    <form [formGroup]="entitateForm">
                        <div class="row">
                            <div class="col-md-12">
                                <mat-form-field class="w-100">
                                    <mat-label>Nume și Prenume</mat-label>
                                    <input type="text" matInput formControlName="name" />
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <mat-form-field>
                                    <mat-label>CNP</mat-label>
                                    <input type="text" matInput formControlName="cnp" />
                                </mat-form-field>
                            </div>
                            <div class="col-md-6">
                                <mat-form-field>
                                    <mat-label>Nr. dosar</mat-label>
                                    <input type="text" matInput formControlName="nr_dosar" />
                                </mat-form-field>
                            </div>
                        </div>
                    </form>
                </div>

                <div class="inregistrare-content-form-right">
                    <button class="nextBtn" (click)="findEntitate()">
                        CAUTĂ
                    </button>
                </div>
            </div>

            <!-- Rezultate entitati -->
            <div class="inregistrare-content-entitati" *ngIf="entitati.length > 0">
                <span class="inregistrare-content-entitati-title">Selectați Beneficiar / Dosar</span>
                <div class="entitati-list">
                    <div class="entitate-row" *ngFor="let entitate of entitati">
                        <div class="entitate-row__info">
                            <div class="entitate-row__col">
                                <span class="entitate-row__label">Nr. Dosar</span>
                                <span class="entitate-row__value">{{ 'N/A' }}</span>
                            </div>
                            <div class="entitate-row__col">
                                <span class="entitate-row__label">Nume Prenume</span>
                                <span class="entitate-row__value">{{ entitate.full_name }}</span>
                            </div>
                            <div class="entitate-row__col">
                                <span class="entitate-row__label">CNP</span>
                                <span class="entitate-row__value">{{ entitate.cnp }}</span>
                            </div>
                            <div class="entitate-row__col">
                                <span class="entitate-row__label">Adresă</span>
                                <span class="entitate-row__value">
                                    {{ entitate.current_address?.formatted_address || 'N/A' }}
                                </span>
                            </div>
                            <div class="entitate-row__col">
                                <span class="entitate-row__label">Tutore</span>
                                <span class="entitate-row__value">
                                    {{ entitate.tutore_relationships.length > 0 ?
                                    entitate.tutore_relationships[0].related_entity_name : 'N/A' }}
                                </span>
                            </div>
                        </div>
                        <div class="entitate-row__action">
                            <button class="continua-btn" (click)="selectEntitate(entitate)">
                                CONTINUĂ
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>

        <!-- ═══════════════ DRAFTURI ═══════════════ -->
        <ng-container *ngIf="mode === 'drafturi'">
            <span class="inregistrare-content-title">Identificare copil</span>

            <div class="inregistrare-content-form d-flex gap-3">
                <div class="inregistrare-content-form-left">
                    <form [formGroup]="entitateForm">
                        <div class="row">
                            <div class="col-md-12">
                                <mat-form-field class="w-100">
                                    <mat-label>Nume și Prenume</mat-label>
                                    <input type="text" matInput formControlName="name" />
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <mat-form-field>
                                    <mat-label>CNP</mat-label>
                                    <input type="text" matInput formControlName="cnp" />
                                </mat-form-field>
                            </div>
                            <div class="col-md-6">
                                <mat-form-field>
                                    <mat-label>Nr. dosar</mat-label>
                                    <input type="text" matInput formControlName="nr_dosar" />
                                </mat-form-field>
                            </div>
                        </div>
                    </form>
                </div>

                <div class="inregistrare-content-form-right">
                    <button class="nextBtn" (click)="listDrafturi()">
                        CAUTĂ
                    </button>
                </div>
            </div>

            <!-- Lista drafturi -->
            <div class="inregistrare-content-entitati" *ngIf="drafturi.length > 0">
                <span class="inregistrare-content-entitati-title">Selectați un draft</span>
                <div class="entitati-list">
                    <div class="entitate-row" *ngFor="let draft of drafturi">
                        <div class="entitate-row__info">
                            <div class="entitate-row__col">
                                <span class="entitate-row__label">ID Contract</span>
                                <span class="entitate-row__value">#{{ draft.id }}</span>
                            </div>
                            <div class="entitate-row__col">
                                <span class="entitate-row__label">Beneficiar</span>
                                <span class="entitate-row__value">{{ draft.entity.full_name }}</span>
                            </div>
                            <div class="entitate-row__col">
                                <span class="entitate-row__label">CNP</span>
                                <span class="entitate-row__value">{{ draft.entity.cnp }}</span>
                            </div>
                            <div class="entitate-row__col">
                                <span class="entitate-row__label">Perioadă</span>
                                <span class="entitate-row__value">
                                    {{ draft.date_from_contract | date:'dd.MM.yyyy' }} –
                                    {{ draft.date_end_contract | date:'dd.MM.yyyy' }}
                                </span>
                            </div>
                            <div class="entitate-row__col">
                                <span class="entitate-row__label">Programări contractuale</span>
                                <span class="entitate-row__value">{{ draft.subcontracts.length || 0 }}</span>
                            </div>
                            <div class="entitate-row__col">
                                <span class="entitate-row__label">Creat la</span>
                                <span class="entitate-row__value">{{ draft.created_at | date:'dd.MM.yyyy HH:mm'
                                    }}</span>
                            </div>
                        </div>
                        <div class="entitate-row__action">
                            <button class="continua-btn" (click)="selectDraft(draft)">
                                CONTINUĂ
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="empty-drafturi" *ngIf="drafturi.length === 0 && drafturiLoaded">
                <mat-icon>inbox</mat-icon>
                <span>Nu există drafturi pentru criteriile selectate.</span>
            </div>
        </ng-container>

        <div class="section-spinner position-absolute" *ngIf="isLoading">
            <div class="spinner position-absolute top-50 start-50 translate-middle">
                <mat-spinner></mat-spinner>
                <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
            </div>
        </div>
    </div>
</div>